export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <a href="#top" className="font-heading text-xl text-primary-600">
              178漫画网
            </a>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-foreground-600">
              吃安利，找佳作。汇集漫友真实安利漫画与好漫推荐清单，帮你快速锁定下一部追更目标。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950">推荐专区</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-foreground-600">
              <li><a href="#featured" className="hover:text-primary-600">热门佳作推荐</a></li>
              <li><a href="#genres" className="hover:text-primary-600">主题分类</a></li>
              <li><a href="#toplist" className="hover:text-primary-600">本期安利清单</a></li>
              <li><a href="#reviews" className="hover:text-primary-600">漫友真实评价</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950">帮助与互动</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-foreground-600">
              <li><a href="#faq" className="hover:text-primary-600">常见问题</a></li>
              <li><a href="#submit" className="hover:text-primary-600">投稿安利</a></li>
              <li><a href="#about" className="hover:text-primary-600">关于我们</a></li>
              <li><span className="cursor-default">联系邮箱：hi@178manga.example.com</span></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950">关注我们</h3>
            <p className="mt-4 text-sm text-foreground-600">发现更多好漫推荐，欢迎加入漫友社群。</p>
            <div className="mt-4 flex items-center gap-3">
              <a
                href="#about"
                aria-label="微博"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-secondary-900 transition-colors hover:bg-secondary-200"
              >
                <i className="ri-weibo-fill" aria-hidden="true"></i>
              </a>
              <a
                href="#about"
                aria-label="公众号"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-secondary-900 transition-colors hover:bg-secondary-200"
              >
                <i className="ri-wechat-fill" aria-hidden="true"></i>
              </a>
              <a
                href="#about"
                aria-label="哔哩哔哩"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-secondary-900 transition-colors hover:bg-secondary-200"
              >
                <i className="ri-bilibili-fill" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 178漫画网 · 为漫画爱好者而生的安利推荐平台
          </p>
          <p className="text-xs text-foreground-500">
            一部好漫，值得被更多人看见
          </p>
        </div>
      </div>
    </footer>
  );
}